import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#B07722",
  "fill-rule": "evenodd",
  d: "M35.85 23.319c0 1.1-.891 1.991-1.991 1.991h-11.95V23.32a3.32 3.32 0 1 0-6.64 0v1.991H3.32c-1.1 0-1.991-.891-1.991-1.991V13.36h27.02a7.25 7.25 0 0 0 7.503.522zm-9.958 7.303h-1.328a2.656 2.656 0 0 1-2.655-2.656v-1.328h3.983zM3.32 5.393H25.51a7.3 7.3 0 0 0-.283 1.992c0 .224.014.445.034.664H1.328v-.664c0-1.1.892-1.992 1.992-1.992M1.328 9.377H25.51a7.3 7.3 0 0 0 1.39 2.655H1.329zM32.53 1.41a5.975 5.975 0 1 1-5.975 5.975 5.98 5.98 0 0 1 5.975-5.975m7.303 5.975a7.298 7.298 0 0 0-13.8-3.32H3.32A3.323 3.323 0 0 0 0 7.386V23.32a3.323 3.323 0 0 0 3.32 3.32h5.617l-1.7 3.83a3.34 3.34 0 0 0 .132 2.96l2.343 4.216a2 2 0 0 1 .247.968v.64a.664.664 0 0 0 1.327 0v-.64c0-.564-.144-1.12-.417-1.613l-2.343-4.215a2 2 0 0 1-.079-1.776l1.943-4.37h4.88v4.647a.664.664 0 0 0 1.328 0v-7.967a1.992 1.992 0 1 1 3.983 0v15.933a.664.664 0 0 0 1.328 0v-8.325a3.96 3.96 0 0 0 2.655 1.022h1.992a.664.664 0 0 0 .664-.664v-4.647h6.639a3.323 3.323 0 0 0 3.32-3.32V13.015a7.3 7.3 0 0 0 2.655-5.629",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }